import { createSlice } from '@reduxjs/toolkit';
import ArcadaApiService from 'helpers/service/arcadaApiService';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  branding: null,
  error: null,
};

const slice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    getBrandingSuccess(state, action) {
      state.isLoading = false;
      state.branding = action.payload;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

export function getBranding() {
  return async () => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await ArcadaApiService.branding.getBranding();
      dispatch(slice.actions.getBrandingSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
